<fastr-ui-ai-chat-multi-select
  *ngIf="isMultiSelectGate; else singleSelectInteraction"
  [question]="response?.gate?.question || ''"
  [animateQuestion]="animateQuestion"
  [options]="multiSelectOptions"
  [maxSelections]="multiSelectMaxSelections"
  [allowCustomValue]="!!response?.gate?.allow_other"
  [customValuePlaceholder]="customValuePlaceholder"
  [showSecondaryActions]="showSecondaryActions"
  [showBackAction]="showBackAction"
  (submitted)="onMultiSelectSubmit($event)"
  (reviewAndSearch)="onReviewAndSearch()"
  (refine)="onRefine()"
  (back)="onBack()">
</fastr-ui-ai-chat-multi-select>

<ng-template #singleSelectInteraction>
  <fastr-ui-ai-chat-single-select
    *ngIf="isSingleSelectGate; else simpleInputInteraction"
    [question]="response?.gate?.question || ''"
    [animateQuestion]="animateQuestion"
    [options]="singleSelectOptions"
    [allowCustomValue]="!!response?.gate?.allow_other"
    [customValuePlaceholder]="customValuePlaceholder"
    [showSecondaryActions]="showSecondaryActions"
    [showBackAction]="showBackAction"
    (submitted)="onSingleSelectSubmit($event)"
    (reviewAndSearch)="onReviewAndSearch()"
    (refine)="onRefine()"
    (back)="onBack()">
  </fastr-ui-ai-chat-single-select>
</ng-template>

<ng-template #simpleInputInteraction>
  <fastr-ui-ai-chat-simple-input
    [question]="simpleInputQuestion"
    [animateQuestion]="animateQuestion"
    [placeholder]="simpleInputPlaceholder"
    [showSecondaryActions]="showSecondaryActions"
    [showBackAction]="showBackAction"
    (submitted)="onSimpleInputSubmit($event)"
    (reviewAndSearch)="onReviewAndSearch()"
    (refine)="onRefine()"
    (back)="onBack()">
  </fastr-ui-ai-chat-simple-input>
</ng-template>
